import { useQuery } from '@tanstack/react-query'

import { caaMetricsInstance } from '../..'

export function getOperationalCAAMetricsTherapistWeekQueryKey({
  personaName,
  date
}: {
  personaName?: string
  date: string
}) {
  return ['operationalCAAMetricsTherapistWeek', { personaName, date }]
}

export function useOperationalCAAMetricsTherapistWeekQuery({
  personaName,
  date,
  enabled
}: {
  personaName?: string
  date: string
  enabled?: boolean
}) {
  return useQuery({
    queryKey: getOperationalCAAMetricsTherapistWeekQueryKey({
      personaName,
      date
    }),
    queryFn: async () =>
      await caaMetricsInstance.getOperationalCAAMetricsTherapistWeek({
        personaName,
        date
      }),
    enabled
  })
}
